import React, { useRef } from 'react';
import styles from './LocalConfirmation.module.scss';
import { useOnClickOutside } from '../../hooks/useClickOutside';
import LocalPopup from '../local-popup/LocalPopup';

type Props = {
  children: React.ReactNode;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

function LocalConfirmation(props: Props) {
  const { children, open, onConfirm, onCancel } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(wrapperRef, onCancel);

  return (
    <LocalPopup content={<>
      <div className={styles.title}>Are you sure?</div>
      <div className={styles.actions}>
        <button onClick={onConfirm} className={`${styles.btn} ${styles.btnConfirm}`} type="button">Yes</button>
        <button onClick={onCancel} className={styles.btn} type="button">No</button>
      </div>
    </>} open={open} onClose={onCancel}>
      {children}
    </LocalPopup>
  );
}

export default LocalConfirmation;
